import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: {},
    token: null,
    subscribed: false,
    subscriptionId: null,
    trialStartDate: null,
    trialEndDate: null,
    isInTrial: false,
    trialStatus: null, // Will be fetched from Stripe
    subscriptionCanceling: false,
    subscriptionCancelAt: null,
  },
  reducers: {
    setUser: (state, { payload }) => {
      console.log("payload setUser", payload);
      state.user = {
        // result: payload.result,
        id: payload?.result?._id,
        fullName: payload?.result?.fullName,
        email: payload?.result?.email,
      };
      state.subscribed = payload?.result?.payment_status == 1 ? true : false;
      state.token = payload?.token;
      state.subscriptionId = payload?.result?.subscription_id;
      
      // Trial information will be fetched from Stripe
      state.trialStatus = payload?.result?.trial_status || null;
      state.trialStartDate = payload?.result?.trial_start_date || null;
      state.trialEndDate = payload?.result?.trial_end_date || null;
      state.isInTrial = payload?.result?.is_in_trial || false;
    },
    setSubscription: (state, { payload }) => {
      console.log("payload setSubscription", payload);
      state.subscribed = payload?.subscribed;
      state.subscriptionId = payload?.subscriptionId;
    },
    setTrialStatus: (state, { payload }) => {
      console.log("payload setTrialStatus", payload);
      state.trialStatus = payload?.trial_status || null;
      state.trialStartDate = payload?.trial_start_date || null;
      state.trialEndDate = payload?.trial_end_date || null;
      state.isInTrial = payload?.is_in_trial || false;
      state.subscribed = payload?.subscribed || false;
      state.subscriptionCanceling = payload?.subscription_canceling || false;
      state.subscriptionCancelAt = payload?.subscription_cancel_at || null;
      
      // Also update user object with subscription dates for billing display
      if (payload?.subscription_end_date || payload?.access_expires_at) {
        state.user = {
          ...state.user,
          subscription_end_date: payload?.subscription_end_date,
          access_expires_at: payload?.access_expires_at,
          subscription_canceling: payload?.subscription_canceling,
          subscription_cancel_at: payload?.subscription_cancel_at
        };
      }
      
      console.log('[setTrialStatus] Updated state:', {
        trialStatus: state.trialStatus,
        isInTrial: state.isInTrial,
        subscribed: state.subscribed,
        subscriptionCanceling: state.subscriptionCanceling
      });
    },
    setUserData: (state, { payload }) => {
      state.user.fullName = payload?.fullName;
    },
    checkTrialStatus: (state) => {
      if (state.isInTrial && state.trialEndDate) {
        const now = new Date();
        const trialEnd = new Date(state.trialEndDate);
        if (now > trialEnd) {
          state.isInTrial = false;
        }
      }
    },
    endTrial: (state) => {
      state.isInTrial = false;
    },
  },
});
export const { setUser, setSubscription, setUserData, setTrialStatus, checkTrialStatus, endTrial } = authSlice.actions;
export default authSlice.reducer;
